// React / Next
import { motion, Variants } from 'framer-motion';

// SVG container variants for staggered path animations (~15 paths)
const svgContainerVariants: Variants = {
  initial: { opacity: 1 },
  rest: {
    transition: {
      delayChildren: 0.2,
      staggerChildren: 0.015,
      staggerDirection: -1,
    },
  },
  hover: {
    transition: {
      staggerChildren: 0.015,
      staggerDirection: 1,
    },
  },
};

// Path animation variants (vertical slide)
const svgPathVariants: Variants = {
  initial: { y: 280, opacity: 0 },
  rest: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: [0.34, 1.56, 0.64, 1],
    },
  },
  hover: {
    y: 280,
    opacity: 0,
    transition: { duration: 0.3, ease: 'easeIn' },
  },
};

/**
 * CEOsGraphic - Cityscape-style SVG with vertical bars
 * Animates with staggered vertical slide in/out on hover
 */
export const CEOsGraphic = () => (
  <motion.svg
    viewBox="0 0 146 262"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-auto h-full block"
    variants={svgContainerVariants}
    aria-hidden="true"
  >
    <motion.g clipPath="url(#clip0_ceos)">
      <motion.path
        variants={svgPathVariants}
        d="M0.000680685 339.888L2.74222 339.888L2.74225 -1.56557e-05L0.000710399 -1.58954e-05L0.000680685 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M10.8155 339.888L13.4563 339.888L13.4564 -1.56557e-05L10.8155 -1.58866e-05L10.8155 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M21.6308 339.888L24.1709 339.888L24.171 -1.56557e-05L21.6308 -1.58778e-05L21.6308 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M32.4405 339.888L34.8799 339.888L34.8799 -1.56557e-05L32.4405 -1.5869e-05L32.4405 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M43.2607 339.888L45.5938 339.888L45.5938 -1.56557e-05L43.2607 -1.58597e-05L43.2607 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M54.0762 339.888L56.3086 339.888L56.3087 -1.56557e-05L54.0763 -1.58509e-05L54.0762 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M64.891 339.888L67.0227 339.888L67.0228 -1.56557e-05L64.8911 -1.58421e-05L64.891 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M75.7064 339.888L77.7373 339.888L77.7374 -1.56557e-05L75.7064 -1.58333e-05L75.7064 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M86.5212 339.888L88.4514 339.888L88.4515 -1.56557e-05L86.5212 -1.58245e-05L86.5212 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M97.3362 339.888L99.1602 339.888L99.1602 -1.56557e-05L97.3363 -1.58152e-05L97.3362 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M108.152 339.888L109.875 339.888L109.875 -1.56557e-05L108.152 -1.58064e-05L108.152 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M118.966 339.888L120.589 339.888L120.589 -1.56557e-05L118.966 -1.57976e-05L118.966 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M129.782 339.888L131.304 339.888L131.304 -1.56557e-05L129.782 -1.57887e-05L129.782 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M140.602 339.888L142.018 339.888L142.018 -1.56557e-05L140.602 -1.57795e-05L140.602 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M139.494 98.8229L143.125 98.8229L143.125 36.2928L139.494 36.2928L139.494 98.8229Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M128.802 98.8229L132.293 98.8229L132.293 36.2928L128.802 36.2928L128.802 98.8229Z"
        fill="#15B1CD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M139.494 98.8229L143.125 98.8229L143.125 65.5708L139.494 65.5708L139.494 98.8229Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M128.802 98.8229L132.293 98.8229L132.293 65.5708L128.802 65.5708L128.802 98.8229Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M41.3859 339.888L47.8313 339.888L47.8314 65.4311L41.3859 65.4311L41.3859 339.888Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M52.2844 339.888L58.4053 339.888L58.4053 65.4311L52.2844 65.4311L52.2844 339.888Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M63.1946 339.888L68.9854 339.888L68.9854 65.4311L63.1946 65.4311L63.1946 339.888Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M74.094 339.888L79.5603 339.888L79.5604 65.4311L74.0941 65.4311L74.094 339.888Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M84.9986 339.888L90.1348 339.888L90.1348 65.4311L84.9986 65.4311L84.9986 339.888Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M95.9029 339.888L100.709 339.888L100.709 65.4311L95.9029 65.4311L95.9029 339.888Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.803 339.888L111.284 339.888L111.284 65.4311L106.803 65.4311L106.803 339.888Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M117.707 339.888L121.858 339.888L121.858 65.4311L117.707 65.4311L117.707 339.888Z"
        fill="#6AEAFD"
      />
      <motion.path
        variants={svgPathVariants}
        d="M95.9029 339.888L100.709 339.888L100.709 97.515L95.9029 97.515L95.9029 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M106.803 339.888L111.284 339.888L111.284 97.515L106.803 97.515L106.803 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M117.707 339.888L121.858 339.888L121.858 97.515L117.707 97.515L117.707 339.888Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M138.398 339.76L144.172 339.76L144.172 97.0232L138.398 97.0232L138.398 339.76Z"
        fill="#022E40"
      />
      <motion.path
        variants={svgPathVariants}
        d="M127.812 339.76L133.317 339.76L133.317 97.0232L127.812 97.0232L127.812 339.76Z"
        fill="#022E40"
      />
    </motion.g>
    <defs>
      <clipPath id="clip0_ceos">
        <rect
          width="170"
          height="305"
          fill="white"
          transform="translate(170 305) rotate(-180)"
        />
      </clipPath>
    </defs>
  </motion.svg>
);

